// Minimal top bar for the content surfaces (/conteudos and each post).
// The landing (/) has no header by design — this exists only so a reader who
// arrived on a shared link can find their way home and to the archive.
export function SiteHeader() {
  return (
    <header className="sh">
      <a className="sh__home" href="/">
        Lucas Spirandeli
      </a>
      <a className="sh__link" href="/conteudos">
        Reflexões
      </a>
    </header>
  );
}
